import { Box, Divider, Stack, Typography, TypographyProps } from '@mui/joy';

import { Level } from 'theme/enums';

interface IProps extends TypographyProps {
  title: string;
  buttons?: JSX.Element[];
}

const FormSectionHeader = ({ title, buttons = [], level = Level.H3, ...rest }: IProps) => {
  return (
    <Stack>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <Typography level={level} {...rest}>
          {title}
        </Typography>

        {buttons.map((button) => button)}
      </Box>
      <Divider></Divider>
    </Stack>
  );
};

export default FormSectionHeader;
